import { makeStyles } from '@/styles/theme/tss-react';

interface Props {
  xsBackgroundImage: string;
  mdBackgroundImage: string;
}

const useStyles = makeStyles<Props>({
  name: 'ActionBannerFull',
})(({ spacing, breakpoints, aspectRatio, brandColors, typography }, props) => ({
  container: {
    padding: `${spacing(2)} 0`,
    [breakpoints.up('sm')]: {
      padding: `${spacing(4)} 0`,
    },
    // Frame Style
    '&.Dark': {
      backgroundColor: brandColors.tintsHeroBlue10,
    },
    '&.Light': {
      backgroundColor: brandColors.tintsOffWhite60,
    },
  },
  relativePosition: {
    position: 'relative',
  },
  banner: {
    position: 'relative',
    borderTopLeftRadius: typography.pxToRem(16),
    borderTopRightRadius: typography.pxToRem(16),
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    aspectRatio: aspectRatio['1/1'],
    backgroundImage: props.xsBackgroundImage,
    [breakpoints.up('sm')]: {
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: `${brandColors.heroBlue}CC`,
        borderTopLeftRadius: typography.pxToRem(16),
        borderTopRightRadius: typography.pxToRem(16),
      },
    },
    [breakpoints.up('md')]: {
      borderRadius: typography.pxToRem(16),
      aspectRatio: aspectRatio['16/9'],
      backgroundImage: props.mdBackgroundImage,
      '&::before': {
        borderRadius: typography.pxToRem(16),
      },
    },
  },
  absolutePosition: {
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    position: 'absolute',
    margin: '0',
  },
  content: {
    padding: `${spacing(2)} ${spacing(2)} ${spacing(5)} ${spacing(2)}`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    [breakpoints.up('sm')]: {
      paddingLeft: spacing(3),
      paddingRight: spacing(3),
    },
    [breakpoints.up('md')]: {
      height: '100%',
      padding: 0,
    },
  },
  sectionHeaderSubheading: {
    [breakpoints.up('lg')]: {
      width: '77%',
    },
  },
  buttonContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: spacing(2),
    gap: spacing(-1),
  },
  mobileLowerBanner: {
    backgroundColor: 'black',
    borderBottomLeftRadius: typography.pxToRem(16),
    borderBottomRightRadius: typography.pxToRem(16),
    height: '100%',
    '&.OnDark': {
      backgroundColor: brandColors.black,
    },
    '&.OnLight': {
      backgroundColor: brandColors.tintsOffWhite40,
    },
  },
}));

export default useStyles;
